<template>
    <transition name="fade">
        <template v-if="open">
            <transition name="slide-up">
                <div v-if="visible" class="fixed left-0 bottom-0 right-0 transition-transform duration-500 z-50 lg:p-6 lg:left-auto">
                    <div class="bg-dark-red rounded-t-3xl px-9 pt-5 pb-4 lg:rounded-3xl lg:px-6 lg:py-10" :class="wider ? 'lg:w-150' : 'lg:w-popup'">
                        <slot :close="close" :step="step" :next="next" :query="query" :set-values="setValues" :set-cookie="setCookie"/>
                    </div>
                </div>
            </transition>
        </template>
    </transition>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Cookies from 'js-cookie';

@Component
export default class Popup extends Vue {
    @Prop({ default: 'popup' }) layout: 'popup' | 'banner';
    @Prop({ type: Boolean, default: false }) wider: boolean;
    @Prop() id: string;
    @Prop({ default: -1 }) autostart: number;

    open = false;
    visible = false;
    step = 0;
    values: string[] = [];

    created(): void {
        this.$root.$on('open-popup', this.onOpen);
        this.initCookie();
    }

    mounted(): void {
        const alreadyShown = !!Cookies.get('popup-shown');
        if (this.autostart > 0 && !alreadyShown) {
            setTimeout(() => {
                this.onOpen(this.id);
            }, this.autostart * 1000);
        }
    }

    onOpen(id: string): void {
        if (id === this.id) {
            this.open = true;
            setTimeout(() => {
                this.visible = true;
            }, 300);
        }
    }

    next(): void {
        this.step++;
    }

    initCookie(): void {
        if (!Cookies.get('categories')) {
            Cookies.set('categories', 'none');
        }
    }

    updateCookie(): void {
        Cookies.set('categories', this.values.join(', '));
    }

    setCookie(): void {
        Cookies.set('popup-shown', 'true');
    }

    close(): void {
        this.visible = false;
        setTimeout(() => {
            this.open = false;
            this.step = 0;
        }, 300);
        Cookies.set('categories', 'none');
        this.setCookie();
    }

    setValues(values: string[]): void {
        this.values = values;
        this.updateCookie();
    }

    get query(): string {
        if (this.values.length) {
            return `#categories:${this.values.join(',')}`;
        }
        return '';
    }
}
</script>
